import inputBorderDark from '../../input/border-color/default/dark';

const dark = (params) => inputBorderDark(params);

export default dark;
